import React, {PropTypes, Component} from 'react';
import {I18N, CONFIG} from '../../../globals/config';
import SignFooter from './sign-footer';
import classNames from 'classnames';

const api = CONFIG.api + 'join_modal/';

class ForgotPassword extends Component {
	constructor( props ){
		super( props );
		this.state = {
			user_login : "",
			message : '<p>' + I18N.reset_password_desc + '</p>',
			error : false,
		};

		this.onChange        = this.onChange.bind( this );
		this._reset_password = this._reset_password.bind( this );
	}

	onChange( event ){
		this.state[event.target.name] = event.target.value;
		this.setState( this.state );
	}

	_reset_password(){
		let data    = this.state;
		data.method = 'reset_password';

		$.post( api, data, function( response ){
			if( _.isObject( response ) ){
				this.setState( {
					message : response.data,
					error   : !response.success,
				} );

			}
		}.bind( this ) );

	}


	render(){
		let $classes = {
			error : this.state.error,
			update : !this.state.error
		};

		return (
			<div className="form-wrap">
				<h2>
					{I18N.forget_password}
				</h2>
				{!_.isEmpty( this.state.message ) && <div className={classNames($classes)} dangerouslySetInnerHTML={EdspireGrunt.fn.react_html_markup(this.state.message)} />}

				<input
					type="text"
					name="user_login"
					value={this.state.user_login}
					onChange={this.onChange}
					placeholder={I18N.email}
				/>

				<input
					className="button button-primary"
					type="submit"
					name="join-submit"
					value={I18N.reset_password}
					onClick={this._reset_password.bind( this )}
				/>

				<SignFooter changeStep={this.props.changeStep}/>
			</div>
		)
	}
}

ForgotPassword.propTypes = {
	changeStep : PropTypes.func.isRequired
};


export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/modals/join/forgot-password.js